"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderProjectSection = renderProjectSection;
var _litHtml = require("lit-html");
require("solid-ui/components/actions/button");
var _texts = require("../../texts");
var _ProjectEditDialog = require("./ProjectEditDialog");
var _mutations = require("./mutations");
var _profileIcons = require("../../icons-svg/profileIcons");
require("./ProjectSection.css");
var _collapsibleSection = require("../shared/collapsibleSection");
var _spinner = require("../../ui/spinner");
var _errorDisplay = require("../../utils/errorDisplay");
const MAX_VISIBLE_PROJECTS_MOBILE = 2;
function setProjectsSectionError(section, message) {
  const errorBox = section.querySelector('.profile-section-inline-error');
  if (!errorBox) return;
  if (!message) {
    errorBox.textContent = '';
    errorBox.hidden = true;
    errorBox.setAttribute('aria-hidden', 'true');
    return;
  }
  errorBox.textContent = message;
  errorBox.hidden = false;
  errorBox.setAttribute('aria-hidden', 'false');
  errorBox.focus();
}
function toggleProjectsMobileList(event) {
  const button = event.currentTarget;
  const section = button?.closest('.profile-section-collapsible');
  if (!button || !section) return;
  const nextExpanded = section.getAttribute('data-mobile-expanded') !== 'true';
  section.setAttribute('data-mobile-expanded', String(nextExpanded));
  button.setAttribute('aria-expanded', String(nextExpanded));
  button.setAttribute('data-mobile-expanded', String(nextExpanded));
  const label = button.querySelector('.project-card__more-label');
  if (label) {
    label.textContent = nextExpanded ? 'View Less' : 'View More';
  }
}
function renderProjectImage(src, altText) {
  return src ? (0, _litHtml.html)`
        <img
          class="project-card__thumb-image"
          src=${src}
          alt=${altText}
          loading="lazy"
        />
      ` : (0, _litHtml.html)`
        <div class="project-card__thumb-fallback" role="img" aria-label=${altText}>
          ${altText}
        </div>
      `;
}
function toProjectRow(project, status) {
  return {
    url: project.url,
    title: project.title,
    imageUrl: project.imageUrl,
    category: project.category,
    name: project.name,
    orgName: project.orgName,
    entryNode: project.entryNode?.value || '',
    status
  };
}
function renderProject(project, store, subject, viewerMode, onSaved) {
  if (!project) return (0, _litHtml.html)``;
  const handleUnfollow = async event => {
    event.preventDefault();
    event.stopPropagation();
    if (viewerMode !== 'owner') return;
    const unfollowButton = event.currentTarget;
    const section = event.currentTarget?.closest('[data-profile-section="projects"]');
    const removePlan = {
      create: [],
      update: [],
      remove: [toProjectRow(project, 'deleted')]
    };
    try {
      unfollowButton?.setAttribute('disabled', '');
      unfollowButton?.setAttribute('data-loading', 'true');
      unfollowButton?.setAttribute('aria-busy', 'true');
      await (0, _mutations.processProjectsMutations)(store, subject, removePlan);
      if (section) {
        setProjectsSectionError(section, null);
      }
      if (onSaved) {
        await onSaved();
      }
    } catch (error) {
      if (section) {
        setProjectsSectionError(section, (0, _errorDisplay.formatDisplayError)(error, _texts.unfollowProjectFailedMessageText));
      }
    } finally {
      unfollowButton?.removeAttribute('disabled');
      unfollowButton?.removeAttribute('data-loading');
      unfollowButton?.setAttribute('aria-busy', 'false');
    }
  };
  const normalizedCategory = (project.category || '').trim().toLowerCase();
  const categoryModifier = normalizedCategory === 'project' ? 'project' : normalizedCategory === 'community' ? 'community' : 'unknown';
  const categoryLabel = normalizedCategory && normalizedCategory !== 'unknown' ? normalizedCategory.charAt(0).toUpperCase() + normalizedCategory.slice(1) : 'Uncategorized';
  return (0, _litHtml.html)`
    <li class="project-card" role="listitem">
      <a
        class="project-card__link"
        href=${project.url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label=${project.title ? `Open ${project.title}` : 'Open project link'}
      >
        <div class="project-card__wrapper">
          <div class="project-card__thumb">
            ${renderProjectImage(project.imageUrl, project.title || 'Project preview')}
          </div>
          <div class="project-card__content">
            <div class="project-card__heading-group">
              <h3 class="project-card__title">${project.title || project.url}</h3>
              <p class="project-card__organization">${project.orgName || 'Organization unknown'}</p>
            </div>
            <p class="project-card__category project-card__category--${categoryModifier}">${categoryLabel}</p>
          </div>
        </div>
      </a>
      ${viewerMode === 'owner' ? (0, _litHtml.html)`
        <div class="project-card__footer">
          <solid-ui-button
            type="button"
            variant="secondary"
            size="sm"
            label="Following"
            class="project-card__follow-button"
            aria-label="Unfollow project"
            @click=${handleUnfollow}
          >
            <span class="project-card__follow-label project-card__follow-label--default">${_profileIcons.checkMarkIcon} Following</span>
            <span class="project-card__follow-label project-card__follow-label--hover">Unfollow</span>
            <span class="project-card__follow-label project-card__follow-label--loading">${(0, _spinner.createSpinner)()}<span>Unfollowing...</span></span>
          </solid-ui-button>
        </div>
      ` : (0, _litHtml.html)``}
    </li>
  `;
}
function renderOwnerEmptyProjectsContent(store, subject, projectData, viewerMode, onSaved) {
  const projectDetails = projectData;
  return (0, _litHtml.html)`
    <div class="profile__empty-state-content" role="group" aria-label="Empty projects section">
      <h2 id="projects-heading" tabindex="-1">${_texts.projectsHeadingText}</h2>
      <p class="profile__empty-state-message">
        You haven't added any projects yet. Consider adding a project to boost your profile.
      </p>
    </div>
    <solid-ui-button
      type="button"
      variant="secondary"
      size="sm"
      class="profile__action-button--empty"
      aria-label="Add project details"
      @click=${event => {
    return (0, _ProjectEditDialog.createProjectsEditDialog)(event, store, subject, projectDetails, viewerMode, onSaved);
  }}
    >
      <span class="profile__action-icon" aria-hidden="true">${_profileIcons.plusDarkIcon} Add Project</span>
    </solid-ui-button>

  `;
}
function renderOwnerEmptyProjectSection(store, subject, projectData, viewerMode, onSaved) {
  return (0, _litHtml.html)`
    <section 
      aria-labelledby="projects-heading" 
      data-profile-section="projects"
      class="profile__section--empty profile__section--empty-main profile-section-collapsible profile-section-collapsible--inline-mobile-actions profile-section-collapsible--empty-mobile-no-edit" 
      role="region"
      tabindex="-1"
      data-expanded="false"
    >
      <header class="profile__section-header profile-section-collapsible__header">
        <h2 id="projects-heading" tabindex="-1">${_texts.projectsHeadingText}</h2>
        <div class="profile-section-collapsible__actions">
          <solid-ui-button
            type="button"
            variant="icon"
            size="sm"
            class="profile-section-collapsible__toggle-button"
            aria-label="Toggle projects section"
            aria-controls="projects-panel"
            aria-expanded="false"
            @click=${_collapsibleSection.toggleCollapsibleSection}
          >
            <span slot="icon" class="profile-section-collapsible__chevron" aria-hidden="true">${_profileIcons.chevronDownIcon}</span>
          </solid-ui-button>
        </div>
      </header>
      <div id="projects-panel" class="profile-section-collapsible__content">
        ${renderOwnerEmptyProjectsContent(store, subject, projectData, viewerMode, onSaved)}
      </div>
    </section>
  `;
}
function renderProjectSectionContent(projects, store, subject, viewerMode, onSaved) {
  if (!projects || !projects.length || !projects[0]) return (0, _litHtml.html)``;
  return (0, _litHtml.html)`${renderProject(projects[0], store, subject, viewerMode, onSaved)}${projects.length > 1 ? renderProjectSectionContent(projects.slice(1), store, subject, viewerMode, onSaved) : (0, _litHtml.html)``}`;
}
function renderProjectSectionDefault(store, subject, projects, viewerMode, onSaved) {
  const hasProjects = Array.isArray(projects) && projects.length > 0;
  const hiddenProjectsCount = Math.max(0, projects.length - MAX_VISIBLE_PROJECTS_MOBILE);
  const isOwner = viewerMode === 'owner';
  return (0, _litHtml.html)`
      <section
        class="profile__section profile-section-collapsible profile-section-collapsible--inline-mobile-actions"
        data-profile-section="projects"
        aria-labelledby="projects-heading"
        role="region"
        tabindex="-1"
        data-expanded="false"
        data-mobile-expanded="${hiddenProjectsCount > 0 ? 'false' : 'true'}"
      >
        <header class="profile__section-header profile-section-collapsible__header">
          <h2 id="projects-heading">${_texts.projectsHeadingText}</h2>
          <div class="profile-section-collapsible__actions">
            ${isOwner ? (0, _litHtml.html)`
              <solid-ui-button
                type="button"
                variant="secondary"
                size="sm"
                class="profile__action-button profile-action-text profile-section-collapsible__edit-button"
                aria-label="Add or edit projects"
                @click=${event => {
    return (0, _ProjectEditDialog.createProjectsEditDialog)(event, store, subject, projects, viewerMode, onSaved);
  }}
              >
                <span class="profile-section-collapsible__edit-label profile__add-more-content">
                  <span class="profile__add-more-icon" aria-hidden="true">${_profileIcons.addIcon}</span>
                  <span>Add More</span>
                </span>
                <span class="profile-section-collapsible__edit-icon" aria-hidden="true">${_profileIcons.editIcon}</span>
              </solid-ui-button>
            ` : (0, _litHtml.html)``}
            <solid-ui-button
              type="button"
              variant="icon"
              size="sm"
              class="profile-section-collapsible__toggle-button"
              aria-label="Toggle projects section"
              aria-controls="projects-panel"
              aria-expanded="false"
              @click=${_collapsibleSection.toggleCollapsibleSection}
            >
              <span slot="icon" class="profile-section-collapsible__chevron" aria-hidden="true">${_profileIcons.chevronDownIcon}</span>
            </solid-ui-button>
          </div>
        </header>
        <div id="projects-panel" class="profile-section-collapsible__content">
          ${hasProjects ? (0, _litHtml.html)`
                <ul id="projects-rail" class="project-card__rail" role="list" aria-label="Known projects">
                  ${renderProjectSectionContent(projects, store, subject, viewerMode, onSaved)}
                </ul>
                ${hiddenProjectsCount > 0 ? (0, _litHtml.html)`
                      <solid-ui-button
                        type="button"
                        variant="secondary"
                        size="sm"
                        label="View More"
                        class="project-card__more-button"
                        aria-controls="projects-rail"
                        aria-expanded="false"
                        data-mobile-expanded="false"
                        @click=${toggleProjectsMobileList}
                      >
                        <span class="project-card__more-icon" aria-hidden="true">${_profileIcons.twoDownArrowsIcon}</span>
                        <span class="project-card__more-label">View More</span>
                      </solid-ui-button>
                    ` : (0, _litHtml.html)``}
                <div
                  class="profile-section-inline-error"
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                  aria-hidden="true"
                  tabindex="-1"
                  hidden
                ></div>
              ` : (0, _litHtml.html)`<p>No projects added yet.</p>`}
        </div>
      </section>
    `;
}
function renderProjectSection(store, subject, projects, viewerMode, onSaved) {
  const hasProjects = Array.isArray(projects) && projects.length > 0;
  const showOwnerEmptyProject = !hasProjects && viewerMode === 'owner';
  const showSection = true;
  return showSection ? (0, _litHtml.html)`
    ${showOwnerEmptyProject ? renderOwnerEmptyProjectSection(store, subject, projects, viewerMode, onSaved) : renderProjectSectionDefault(store, subject, projects, viewerMode, onSaved)}
  ` : '';
}